module.exports = __webpack_public_path__ + "assets/nikotin.fe249d1e.svg";